export default __webpack_public_path__ + "2819d2748ba9f1b56a38062e59f58b57.svg";